import { faker } from '@faker-js/faker';
import { DealroomEventType } from '../../../api/timeline/types/log.types';
import type { NotificationEvent } from '../notification.types';

export default class NotificationEventMock {
  private static mockableEvents = [
    DealroomEventType.FileUploaded,
    DealroomEventType.ContextualCommentReplyCreated,
    DealroomEventType.ConversationMessageCreated,
    DealroomEventType.Visited,
  ];

  static one(properties?: Partial<NotificationEvent>): NotificationEvent {
    return {
      id: faker.datatype.uuid(),
      participantId: faker.datatype.uuid(),
      eventName: faker.lorem.words(3),
      createdAt: faker.date.past().getTime(),
      type: this.mockableEvents[
        faker.datatype.number({ min: 0, max: this.mockableEvents.length - 1 })
      ],
      isRead: false,
      eventTitle: faker.lorem.words(3),
      ...properties,
    };
  }

  static many(count = 2): NotificationEvent[] {
    const notificationEvents: NotificationEvent[] = [];
    for (let i = 0; i < count; i++) {
      notificationEvents.push(this.one());
    }
    return notificationEvents;
  }
}
